import { ComponentData } from './../../models/dynamic-component/component-data.model';
import {
    Component,
    OnInit,
    Input,
    ViewChild,
    ViewContainerRef,
    ComponentFactoryResolver,
    AfterViewInit,
    Renderer2,
    ElementRef } from '@angular/core';
import { DynamicComponentService } from './../../services/dynamic-component.service';

@Component({
  selector: 'ngxui-component-factory',
  templateUrl: './component-factory.component.html',
  styleUrls: ['./component-factory.component.scss'],

})
export class ComponentFactoryComponent implements OnInit, AfterViewInit {
    @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer: ViewContainerRef;
   /* @ViewChild('dynamicComponentContainer', { read: ElementRef }) dynamicComponentContainer: ElementRef;*/


    compData: ComponentData;
    @Input() set componentData(data: ComponentData) {
        if (!data) {
            return;
        }
        else {
            this.compData = data;

        }
    }
    get componentData(): ComponentData { return this.compData; }

    guidId: any;

    constructor(
        private dynamicComponentService: DynamicComponentService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private vcr: ViewContainerRef,
        private renderer: Renderer2,
        private ele: ElementRef
    ) { }

    ngOnInit() {
        const time = new Date();
        this.guidId = time.getTime();
    }

    ngAfterViewInit(){
        let me = this;

        this.dynamicComponentService.addDynamicComponent2(this.componentData, me.dynamicComponentContainer, me.componentFactoryResolver)
        /*this.dynamicComponentService.addDynamicComponent(
            me.componentData,
            me.ele,
            me.vcr,
            me.componentFactoryResolver,
            me.renderer
        )*/
    }

}
